import axios, { AxiosResponse } from 'axios'

import { StripeReaderId, StripeReaderRead } from '@generated/types'

const BASE_URL = '/api/stripe/reader'

export default {
  async fetchReaders(): Promise<AxiosResponse<StripeReaderRead[]>> {
    return axios.get(`${BASE_URL}/`)
  },

  async cancelAction(readerId: StripeReaderId): Promise<AxiosResponse<StripeReaderRead>> {
    return axios.post(`${BASE_URL}/cancel/`, { reader_id: readerId })
  },

  async simulatePayment(
    readerId: StripeReaderId,
    cardNumber: string,
  ): Promise<AxiosResponse<StripeReaderRead>> {
    return axios.post(`${BASE_URL}/simulate/`, {
      reader_id: readerId,
      card_number: cardNumber,
    })
  },
}
